import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { School, ShieldCheck, Users, Check, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SchoolEnquiryForm } from "@/components/SchoolEnquiryForm";
import { TeacherTestimonials } from "@/components/TeacherTestimonials";

const POINTS = [
  { icon: Users, t: "Whole class, one price", d: "£400 unlocks a full 10-lesson course for every student in your class, now and in the future." },
  { icon: ShieldCheck, t: "School email verified", d: "We email a 6-digit code to your school email address to confirm you're a teacher." },
  { icon: Check, t: "Teacher tools included", d: "Join codes, assignments, due-date reminders, progress tracking and printable report cards." },
];

export const TeacherRates = () => {
  useEffect(() => {
    if (window.location.hash === "#teacher-rates") {
      setTimeout(() => document.getElementById("teacher-rates")?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    }
  }, []);

  return (
    <div id="teacher-rates" className="mt-14 scroll-mt-24 rounded-3xl border border-primary/30 bg-card p-8" data-testid="pricing-teacher-rates">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-xl">
          <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-primary"><School size={14} /> Schools & teachers</p>
          <h2 className="mt-2 font-serif text-3xl">Teacher rates for whole class sign up</h2>
          <p className="mt-3 text-muted-foreground">
            Bring Jason's 10-lesson reading method to your whole classroom with one licence.
          </p>
        </div>
        <div className="text-right">
          <p className="font-serif text-4xl text-foreground" data-testid="teacher-rate-price">£400</p>
          <p className="text-xs text-muted-foreground">per class, per course</p>
        </div>
      </div>
      <div className="mt-8 grid gap-4 sm:grid-cols-3">
        {POINTS.map((p) => (
          <div key={p.t} className="rounded-2xl border border-border bg-background p-5">
            <p.icon size={18} className="text-primary" />
            <p className="mt-3 font-semibold">{p.t}</p>
            <p className="mt-1 text-sm text-muted-foreground">{p.d}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3">
        <Link to="/register?role=teacher" data-testid="teacher-rates-signup">
          <Button className="mt-8 rounded-full bg-primary px-8 py-6 font-semibold text-primary-foreground hover:bg-primary/90">
            Sign up as a teacher
          </Button>
        </Link>
        <a href="/media/jt-hub-school-brochure.pdf" download="The-JT-Hub-School-Brochure.pdf" data-testid="school-brochure-download">
          <Button variant="outline" className="mt-8 rounded-full border-primary/40 px-8 py-6 font-semibold text-primary hover:bg-primary/10">
            <Download size={16} className="mr-2" /> Download school brochure (PDF)
          </Button>
        </a>
      </div>
      <TeacherTestimonials />
      <SchoolEnquiryForm />
    </div>
  );
};
